import React from 'react';
import clsx from 'clsx';
import { REACTION_EMOJI, ReactionKind } from '../utils/messageReactions';

export type ReactionMenuContext = { messageId: string; x: number; y: number } | null;

export const ReactionMenu = ({
  context,
  sending,
  error,
  onClose,
  onSelect,
  menuRef,
}: {
  context: ReactionMenuContext;
  sending: boolean;
  error: string | null;
  onClose: () => void;
  onSelect: (reaction: ReactionKind) => void;
  menuRef?: React.Ref<HTMLDivElement>;
}) => {
  if (!context) return null;

  const width = 264;
  const height = error ? 92 : 56;
  const left = typeof window !== 'undefined' ? Math.min(context.x, window.innerWidth - width - 12) : context.x;
  const top = typeof window !== 'undefined' ? Math.min(context.y, window.innerHeight - height - 12) : context.y;
  const reactions = Object.entries(REACTION_EMOJI) as Array<[ReactionKind, string]>;

  return (
    <div
      ref={menuRef}
      className="fixed z-[60]"
      style={{ left, top }}
      onClick={(event) => event.stopPropagation()}
      onContextMenu={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }}
    >
      <div className="rounded-2xl border border-gray-200/70 dark:border-gray-700/60 bg-white/95 dark:bg-gray-950/90 p-2 shadow-2xl backdrop-blur">
        <div className="flex items-center gap-1">
          {reactions.map(([key, emoji]) => (
            <button
              key={key}
              type="button"
              disabled={sending}
              onClick={() => onSelect(key)}
              className={clsx(
                'flex h-9 w-9 items-center justify-center rounded-xl text-lg transition',
                sending
                  ? 'opacity-60'
                  : 'hover:bg-gray-100 active:bg-gray-200 dark:hover:bg-gray-900 dark:active:bg-gray-800'
              )}
              aria-label={`React with ${key}`}
              title={`React: ${key}`}
            >
              {emoji}
            </button>
          ))}
        </div>
        {error && <p className="mt-2 max-w-[240px] text-xs text-red-600 dark:text-red-200">{error}</p>}
      </div>
    </div>
  );
};


